module.exports = __webpack_public_path__ + "img/roll-730.a8e8b568.png";